import { APIModel } from '@shared/interfaces';

import { Language } from '@/organisations/models';

export class QuestionFieldLabel implements APIModel {
    id = -1;
    language: Language = Language.NL;
    text: string = '';

    deserialize(data: any) {
        this.id = data.id ?? -1;
        this.language = data.language ?? Language.NL;
        this.text = data.text ?? -1;
        return this;
    }
}
